import PropTypes from 'prop-types';
import { createContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

// hook
import useAuth from '../hooks/useAuth';
import useNotification from '../hooks/useNotification';
import eventTypes from '../utils/eventTypes';
// ----------------------------------------------------------------------

const initialState = {
  socket: null,
  connected: false
};

const SocketContext = createContext(initialState);

SocketProvider.propTypes = {
  children: PropTypes.node
};

function SocketProvider({ children }) {
  const { isAuthenticated, user } = useAuth();
  const [connected, setConnected] = useState(false);
  const { getNotification } = useNotification();
  const getNotificationRef = useRef(getNotification);
  const socketRef = useRef(null);

  useEffect(() => {
    getNotificationRef.current = getNotification;
  }, [getNotification]);

  useEffect(() => {
    if (!isAuthenticated || !user) return undefined;

    if (!socketRef.current) {
      socketRef.current = io(process.env.REACT_APP_API_CREA, { autoConnect: false });
    }

    const socket = socketRef.current;

    socket.auth = {
      userId: user.id,
      typeUser: user.typeUser
    };

    const onConnect = () => {
      setConnected(true);
    };

    const onNotification = async () => {
      await getNotificationRef.current();
    };

    socket.on('connect', onConnect);
    socket.on(eventTypes.notification, onNotification);

    if (!socket.connected) {
      socket.connect();
    }

    return () => {
      socket.off('connect', onConnect);
      socket.off(eventTypes.notification, onNotification);
    };
  }, [isAuthenticated, user]);

  return <SocketContext.Provider value={{ socket: socketRef.current, connected }}>{children}</SocketContext.Provider>;
}

export { SocketProvider, SocketContext };
